import React, { useState, useEffect } from 'react';
import './Hero.css';
import HeroNewsSlider from './HeroNewsSlider';
import { API_BASE, mediaSrc } from '../utils/api';

/**
 * API'den slayt gelmezse (ilk kurulum, ağ hatası, yönetici hepsini gizlemişse)
 * hero lacivert boş bir alan olarak kalmasın. Sunucudaki tohum kayıtları da bu
 * üç görselle aynı — normal durumda ilk boyamada indirilen görsel değişmez.
 */
const FALLBACK_SLIDES = [
  { id: 'fallback-1', image: '/images/stadium1.jpg' },
  { id: 'fallback-2', image: '/images/stadium2.jpg' },
  { id: 'fallback-3', image: '/images/stadium3.jpg' },
];

const SLIDE_INTERVAL = 5000;
/** İlk boyamada tek görsel insin (LCP); kalanlar hemen ardından arka planda yüklensin. */
const PRELOAD_DELAY = 1500;

const Hero = () => {
  const [slides, setSlides] = useState(FALLBACK_SLIDES);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [preloadRest, setPreloadRest] = useState(false);

  useEffect(() => {
    let cancelled = false;

    fetch(`${API_BASE}/api/hero`)
      .then((r) => r.json())
      .then((data) => {
        if (cancelled || !data || !data.success) return;
        const items = (data.items || []).filter((s) => s && s.image);
        if (items.length === 0) return; // yayında slayt yoksa varsayılanlarda kal
        setSlides(items);
        setCurrentIndex(0);
      })
      .catch(() => {});

    return () => { cancelled = true; };
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => setPreloadRest(true), PRELOAD_DELAY);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (slides.length < 2) return undefined;
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % slides.length);
    }, SLIDE_INTERVAL);
    return () => clearInterval(interval);
  }, [slides.length]);

  return (
    <div className="hero-container">
      {/* Arka plan slaytları — dekoratif, ekran okuyucudan gizli */}
      {slides.map((slide, index) => {
        // Henüz sırası gelmemiş slaytlar DOM'a girmez; background-image opacity:0 olsa
        // bile indirilir ve ilk açılışta boşuna yüzlerce KB'a mal olur.
        if (index !== 0 && !preloadRest) return null;
        return (
          <div
            key={slide.id || index}
            className={`hero-slide ${index === currentIndex ? 'active' : ''}`}
            style={{
              backgroundImage: `url("${mediaSrc(slide.image)}")`,
              backgroundColor: '#00205b',
            }}
            aria-hidden="true"
          />
        );
      })}
      {/* Gradient Overlay */}
      <div className="hero-gradient-overlay" />
      {/* Centered News Slider */}
      <div className="hero-news-slider-center">
        <HeroNewsSlider />
      </div>
    </div>
  );
};

export default Hero;
